import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  OnInit,
} from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PhoneInputNumberComponent } from '../../../phone-input-number/phone-input-number.component';

@Component({
  selector: 'etoh-ng-ant-phone-input-number',
  templateUrl: './ng-ant-phone-input-number.component.html',
  styleUrls: ['./ng-ant-phone-input-number.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NgAntPhoneInputNumberComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => NgAntPhoneInputNumberComponent),
      multi: true,
    },
  ],
})
export class NgAntPhoneInputNumberComponent
  extends PhoneInputNumberComponent
  implements OnInit
{
  constructor() {
    super();
  }
}
